module.exports = __webpack_public_path__ + "static/img/unit_settings.4fbb9db6.png";